export function matchSearchQuery(query, channelName) {
    // Карта для транскрипции с английского на русский
    const transcriptionMapToRussian = {
        a: "а",
        b: "б",
        c: "с",
        d: "д",
        e: "е",
        f: "ф",
        g: "г",
        h: "х",
        i: "и",
        j: "й",
        k: "к",
        l: "л",
        m: "м",
        n: "н",
        o: "о",
        p: "п",
        q: "я",
        r: "р",
        s: "с",
        t: "т",
        u: "у",
        v: "в",
        w: "ц",
        x: "к",
        y: "у",
        z: "з",
        ",": "б",
        ".": "ю",
        ";": "ж",
        "`": "ё",
        "[": "х",
        "]": "ъ",
        "'": "э",
    };

    // Карта для транскрипции с русского на английский
    const transcriptionMapFromRussian = {
        а: "a",
        б: "b",
        с: "c",
        д: "d",
        е: "e",
        ф: "f",
        г: "g",
        х: "h",
        и: "i",
        й: "j",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        я: "q",
        р: "r",
        с: "s",
        т: "т",
        у: "u",
        в: "v",
        ц: "w",
        к: "x",
        у: "y",
        з: "z",
        б: ",",
        ю: ".",
        ж: ";",
        ё: "`",
        х: "[",
        ъ: "]",
        э: "'",
    };

    // Логика преобразования текста с учетом layoutMap
    const layoutMap = {
        а: "f",
        б: ",",
        в: "d",
        г: "u",
        д: "l",
        е: "t",
        ё: "`",
        ж: ";",
        з: "p",
        и: "b",
        й: "q",
        к: "r",
        л: "k",
        м: "v",
        н: "y",
        о: "j",
        п: "g",
        р: "h",
        с: "c",
        т: "n",
        у: "e",
        ф: "a",
        х: "[",
        ц: "w",
        ч: "x",
        ш: "i",
        щ: "o",
        ъ: "]",
        ы: "s",
        ь: "m",
        э: "'",
        ю: ".",
        я: "z",
        f: "а",
        ",": "б",
        d: "в",
        u: "г",
        l: "д",
        t: "е",
        "`": "ё",
        ";": "ж",
        p: "з",
        b: "и",
        q: "й",
        r: "к",
        k: "л",
        v: "м",
        y: "н",
        j: "о",
        g: "п",
        h: "р",
        c: "с",
        n: "т",
        e: "у",
        a: "ф",
        "[": "х",
        w: "ц",
        x: "ч",
        i: "ш",
        o: "щ",
        "]": "ъ",
        s: "ы",
        m: "ь",
        "'": "э",
        ".": "ю",
        z: "я",
    };

    const transformText = (text, map) => {
        return text
            ?.split("")
            .map((char) => {
                const lowerChar = char.toLowerCase();
                const transformedChar = map[lowerChar] || char;
                return char === lowerChar
                    ? transformedChar
                    : transformedChar.toUpperCase();
            })
            .join("");
    };

    // Убираем пробелы в начале и конце
    const trimmedQuery = query.trim();
    const trimmedChannelName = channelName?.trim();

    const searchQuery = trimmedQuery.toUpperCase();
    const variationsQuery = [
        searchQuery,
        transformText(trimmedQuery, transcriptionMapToRussian).toUpperCase(),
        transformText(trimmedQuery, transcriptionMapFromRussian).toUpperCase(),
        transformText(trimmedQuery, layoutMap).toUpperCase(),
    ];

    const currentChannelName = trimmedChannelName?.toUpperCase();
    const variationsChannelName = [
        currentChannelName,
        transformText(
            trimmedChannelName,
            transcriptionMapToRussian
        ).toUpperCase(),
        transformText(
            trimmedChannelName,
            transcriptionMapFromRussian
        ).toUpperCase(),
        transformText(trimmedChannelName, layoutMap).toUpperCase(),
    ];

    return variationsQuery.some((queryVariant) =>
        variationsChannelName.some((channelNameVariant) =>
            channelNameVariant.includes(queryVariant)
        )
    );
}
